import { GeoLevel, SVGMap } from './types';
import * as turf from '@turf/turf';

type Map = Record<string, SVGMap>;

const worldMaps: Map = {};
const countryMaps: Map = {};
const featureMaps: Map = {};

export function registerMap(level: GeoLevel, code: string, map: SVGMap): boolean {
    code = code.toLowerCase();

    let maps: Map = {};

    switch (level) {
        case GeoLevel.World:
            maps = worldMaps;
            break;
        case GeoLevel.Country:
            maps = countryMaps;
            break;
        case GeoLevel.Feature:
            maps = featureMaps;
            break;
        default:
            return false;
    }

    maps[code] = map;

    return true;
}

export function getMap(level: GeoLevel, code: string): any | null {
    code = code.toLowerCase();

    let maps: Map = {};

    switch (level) {
        case GeoLevel.World:
            maps = worldMaps;
            break;
        case GeoLevel.Country:
            maps = countryMaps;
            break;
        case GeoLevel.Feature:
            maps = featureMaps;
            break;
        default:
            break;
    }

    let map: any = null;

    if (code in maps) {
        map = maps[code].contour;
        map.properties = {
            type: level,
        };
        // Use the following code snipped to "fluff-up" a feature. For lakes and their surrounding area.
        /*
        let buffered = turf.buffer(map, 5, {
            units: 'kilometers',
        });

        console.log(buffered);

        map = buffered;
        */
    }

    return map;
}

export function reverseMap(level: GeoLevel, lat: number, lng: number): any | null {
    let maps: Map = {};

    switch (level) {
        case GeoLevel.World:
            maps = worldMaps;
            break;
        case GeoLevel.Country:
            maps = countryMaps;
            break;
        case GeoLevel.Feature:
            maps = featureMaps;
            break;
        default:
            break;
    }

    if (level === GeoLevel.World) {
        const map = maps['world'].contour;
        map.properties = {
            type: level,
        };

        return map;
    }

    for (let index in maps) {
        let map = maps[index].reverse;
        let contains = false;
        if (map.type === 'FeatureCollection') {
            for (let feature of map.features) {
                contains = turf.booleanWithin(turf.point([lng, lat]), feature);
                if (!contains) {
                    continue;
                }

                break;
            }
        } else {
            contains = turf.booleanWithin(turf.point([lng, lat]), map);
        }

        if (!contains) {
            continue;
        }

        map = maps[index].contour;

        map.properties = {
            type: level,
        };

        return map;
    }

    return null;
}

type Geometry = {
    type: string;
    coordinates: any;
};

type Feature = {
    type: string;
    geometry: Geometry;
    properties: Record<string, any>;
};

type FeatureCollection = {
    type: string;
    features: Feature[];
};

function convertToFeatureCollection(feature: any): any {
    if (feature.type !== 'Feature') {
        return feature;
    }

    const geometry = feature.geometry;

    if (geometry.type !== 'Polygon') {
        return feature;
    }

    let collection: FeatureCollection = {
        type: 'FeatureCollection',
        features: [],
    };

    for (let c in geometry.coordinates) {
        let feature: Feature = {
            type: 'Feature',
            geometry: {
                type: 'Polygon',
                coordinates: [geometry.coordinates[c].slice()],
            },
            properties: {
                name: 'hallo',
            },
        };

        collection.features.push(feature);
    }

    return collection;
}

function listPolygon(feature: any) {
    if (feature.type !== 'Feature') {
        return;
    }

    const geometry = feature.geometry;

    if (geometry.type !== 'Polygon') {
        return;
    }

    console.log('len(coordinates)', geometry.coordinates.length);

    for (let c in geometry.coordinates) {
        console.log('len(coordinates[' + c + '])', geometry.coordinates[c].length);
    }
}
